/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aichatcoverchoice3Inputs */

const en_aichatcoverchoice3 = /** @type {(inputs: Aichatcoverchoice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Let’s make the cover. Should Pulsify design one, or do you use your own photo?`)
};

const de_aichatcoverchoice3 = /** @type {(inputs: Aichatcoverchoice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestalten wir das Cover. Soll Pulsify eins entwerfen, oder nimmst du ein eigenes Foto?`)
};

/**
* | output |
* | --- |
* | "Let’s make the cover. Should Pulsify design one, or do you use your own photo?" |
*
* @param {Aichatcoverchoice3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aichatcoverchoice3 = /** @type {((inputs?: Aichatcoverchoice3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aichatcoverchoice3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aichatcoverchoice3(inputs)
	return de_aichatcoverchoice3(inputs)
});
export { aichatcoverchoice3 as "aiChatCoverChoice" }